var formatDate = function(date) {
  let monthValue = date.toLocaleString("fr-FR", { month: "long" });
  let dayValue = date.toLocaleString("fr-FR", { weekday: "long" });
  return dayValue + " " + date.getDate() + " " + monthValue + " " + date.getFullYear();
};

export default formatDate;
